const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-top-picks-carousel'] = {
        c: () => require('partner/modules/dobbies-top-picks-carousel/dobbies-top-picks-carousel.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-top-picks-carousel',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-top-picks-carousel'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-top-picks-carousel|dobbies-top-picks-carousel'] = {
                c: () => require('partner/modules/dobbies-top-picks-carousel/dobbies-top-picks-carousel.view.tsx'),
                cn: '__local__-__local__-dobbies-top-picks-carousel'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };